// extracted by mini-css-extract-plugin
export default {"spinner":"laAhw","live-screen":"mLqqJ","live-and-was-live":"PmRMW","personal-lives":"Xq4xk","current-live":"lDXV0","text":"JZ0jm"};